import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const PLAN_KEYS = ['free', 'pro', 'family'];

export default function PricingSection({ onCta }) {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-gray-900 dark:text-white mb-14">
          {t('landing.pricing.title')}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {PLAN_KEYS.map((key) => {
            const isPro = key === 'pro';
            return (
              <div
                key={key}
                className={`card relative ${
                  isPro
                    ? 'border-brand-500 dark:border-brand-400 ring-2 ring-brand-500/20'
                    : ''
                }`}
              >
                {isPro && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                    POPULAR
                  </div>
                )}
                <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                  {t(`landing.pricing.${key}.name`)}
                </h3>
                <div className="text-3xl font-extrabold text-gray-900 dark:text-white my-4">
                  {t(`landing.pricing.${key}.price`)}
                </div>
                <ul className="space-y-3 mb-6">
                  {(t(`landing.pricing.${key}.features`, { returnObjects: true }) || []).map(
                    (feat, i) => (
                      <li key={i} className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                        <Check size={16} className="text-success-500 shrink-0" />
                        {feat}
                      </li>
                    )
                  )}
                </ul>
                <button
                  onClick={onCta}
                  className={`w-full py-3 rounded-xl font-semibold transition-colors ${
                    isPro
                      ? 'bg-brand-600 hover:bg-brand-700 text-white'
                      : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-900 dark:text-white'
                  }`}
                >
                  {t('landing.hero.cta')}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
